import React from 'react';
import {Button, Modal} from "semantic-ui-react";
import '../styles.scss'

const ConfirmModal = ({trigger, setOpen, children, open, label, onConfirm, onClose, closeBtnLabel, confirmBtnLabel, className, disabledBtn, hideClose, hideConfirm}) => {
    return (
        <Modal
            className={className}
            closeIcon
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={trigger}
            size="tiny"
        >
            <Modal.Header>
                {label}
            </Modal.Header>
            <Modal.Content className='modal__content'>
                {children}
            </Modal.Content>
            <Modal.Actions className='modal__actions'>
                {hideClose ? null : (
                    <Button onClick={() => {
                        onClose && onClose();
                        setOpen(false);
                    }}>
                        {closeBtnLabel || 'Нет'}
                    </Button>
                )}
                {hideConfirm ? null : (
                    <Button className='modal__actions_yes' disabled={disabledBtn} onClick={() => {
                        onConfirm && onConfirm();
                        setOpen(false);
                    }}>
                        {confirmBtnLabel || 'Да'}
                    </Button>
                )}
            </Modal.Actions>
        </Modal>
    );
};

export default ConfirmModal;


// WEBPACK FOOTER //
// ./App/components/Modals/ConfirmModal.jsx